export default __webpack_public_path__ + "static/media/imageUpload.2cb58e7a.svg";